import { apiClient } from '@/lib/apiClient';
import type {
  Rota,
  RotaCombo,
  SalvarRotaRequest,
  RotaMontagemItem,
  SalvarRotaMontagemRequest,
  PaginadoResponse,
} from '../types';

export const rotaService = {
  // ── Rotas ────────────────────────────────────────────────────────────
  async getCombo(): Promise<RotaCombo[]> {
    const { data } = await apiClient.get<RotaCombo[]>('/api/rotas');
    return data;
  },

  async listar(params?: {
    busca?: string;
    apenasAtivas?: boolean;
    pagina?: number;
    tamanhoPagina?: number;
  }): Promise<PaginadoResponse<Rota>> {
    const { data } = await apiClient.get<PaginadoResponse<Rota>>('/api/cadastros/rotas', { params });
    return data;
  },

  async getById(id: number): Promise<Rota> {
    const { data } = await apiClient.get<Rota>(`/api/cadastros/rotas/${id}`);
    return data;
  },

  async criar(req: SalvarRotaRequest): Promise<Rota> {
    const { data } = await apiClient.post<Rota>('/api/cadastros/rotas', req);
    return data;
  },

  async atualizar(id: number, req: SalvarRotaRequest): Promise<void> {
    await apiClient.put(`/api/cadastros/rotas/${id}`, req);
  },

  async inativar(id: number): Promise<void> {
    await apiClient.delete(`/api/cadastros/rotas/${id}`);
  },

  // ── Montagem ──────────────────────────────────────────────────────────
  async getMontagemPorRota(rotaId: number): Promise<RotaMontagemItem[]> {
    const { data } = await apiClient.get<RotaMontagemItem[]>('/api/cadastros/rota-montagem', {
      params: { rotaId },
    });
    return data;
  },

  async salvarMontagem(req: SalvarRotaMontagemRequest): Promise<void> {
    await apiClient.post('/api/cadastros/rota-montagem', req);
  },

  async excluirPonto(id: number): Promise<void> {
    await apiClient.delete(`/api/cadastros/rota-montagem/${id}`);
  },
};
